import { render } from "./ExelExample.vue?vue&type=template&id=61fd1dd1&scoped=true"
import script from "./ExelExample.vue?vue&type=script&lang=js"
export * from "./ExelExample.vue?vue&type=script&lang=js"

import "./ExelExample.vue?vue&type=style&index=0&id=61fd1dd1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fd1dd1"]])

export default __exports__